<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits, useAttrs, computed } from 'vue';
import UtilMoney from '@/utils/UtilMoney';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    label: {
        type: String,
        default: ''
    },
    value: {
        type: [String, Number],
        default: 0
    },
    disabled: {
        type: Boolean,
        default: false
    },
    rules: {
        type: Array,
        default: () => []
    },
    type: {
        type: String,
        default: 'number'
    },
    properties: {
        type: Object,
        default: () => ({})
    }
});

/*==================================================================*/
/*================= USE ATTRS ======================================*/
/*==================================================================*/

const attrs = useAttrs();

/*==================================================================*/
/*================== EMITS =========================================*/
/*==================================================================*/

const emits = defineEmits([
    'input',
]);

/*==================================================================*/
/*================== PROPERTIES DO VUETIFY MONEY ===================*/
/*==================================================================*/

const propertiesDoCampo = computed(() => {

    return {
        class: 'c-vuetify-money__input',
        'prepend-icon': 'mdi-currency-brl',
        ...props.properties,
    };

});

/*==================================================================*/
/*================== MÉTODOS =======================================*/
/*==================================================================*/

const onInput = (event) => {

    let valueNumber = UtilMoney.toNumber(event);
    emits('input', valueNumber);

}

</script>

<template>

    <vuetify-money
        class="c-vuetify-money"
        :type="props.type"
        :label="props.label"
        outlined
        :value="props.value"
        :disabled="props.disabled"
        :rules="props.rules"
        hide-details
        :properties="propertiesDoCampo"
        v-bind="attrs"
        @input="onInput"
    ></vuetify-money>

</template>

<style scoped>

.c-vuetify-money{
    padding: 2px;
}

.c-vuetify-money >>> .v-input__slot{
    min-height: 48px;
}

</style>
